import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c5656c8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "juou-card" }
const _hoisted_2 = { class: "qr" }
const _hoisted_3 = { class: "qr-time" }

import {
  JuouProTable,
  JuouProTableColumn,
  JuouProTableData,
  JuouProTableFilter,
  JuouProTableGetDataFunction,
  JuouDangerDialog,
  JuouProForm,
  JuouProFormItem,
  useBaseAsync,
  useRoute,
  useRouter,
  useBaseTenantStore,
} from 'juou-managebase-ui';
import { useApi } from '@/hooks/useApi';
import { ElMessage, ElMessageBox } from 'element-plus';
import { ref } from 'vue';
import dayjs from 'dayjs';
import { getCurrentRootUrl, getCurrentUrl } from '@/utils';
import QrcodeVue from 'qrcode.vue';
import publish from './publish.vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const columns = ref<JuouProTableColumn[]>([]);
const tableRef = ref<InstanceType<typeof JuouProTable>>();
const setTplFormRef = ref<InstanceType<typeof JuouProForm>>();
const publishRef = ref<InstanceType<typeof publish>>();


const baseTenantStore = useBaseTenantStore();
const addInitValue = {

};
const conditionsInitValue = {
};

const setTplItems = ref<JuouProFormItem[]>([]);
const currentWeapp = ref<any>();
let tpls = [] as any[];
const publisStatusOptions = [
  {
    label: '未发布',
    value: undefined,
  },
  {
    label: '需要更新',
    value: 'need_update',
  },
  {
    label: '审核中',
    value: 'review',
  },
  {
    label: '审核失败',
    value: 'review_failure',
  },
  {
    label: '已发布',
    value: 'success',
  },
];

// eslint-disable-next-line max-lines-per-function
const init = useBaseAsync(async() => {
  const tplRes = await useApi().weappTplApi.listWeappTplByTenantweappTpl({});
  tpls = tplRes.data.data || [];
  const tplOptions = tpls.map((item: any) => ({
    label: item.name,
    value: item.id,
  }));

  setTplItems.value = [
    {
      name: 'templateId',
      label: '模板',
      type: 'select',
      rule: [{ required: true }],
      options: tplOptions,
    },
  ];


  columns.value = [

    {
      name: 'remark',
      label: '备注',
      type: 'string',
      isCondition: true,
    },
    {
      name: 'name',
      label: '小程序名称',
      type: 'string',
      isCondition: true,
      rule: [{ required: true }],
      hideEdit: true,
    },
    {
      name: 'appid',
      label: 'AppID',
      type: 'string',
      isCondition: true,
      rule: [{ required: true }],
      hideEdit: true,
    },
    {
      name: 'secret',
      label: 'secret',
      type: 'string',
    },
    {
      name: 'modelId',
      label: 'model_id',
      type: 'string',
    },
    {
      name: 'principalName',
      label: '主体名称',
      type: 'string',
      isCondition: true,
      rule: [{ required: true }],
      hideEdit: true,
    },
    {
      name: 'baseSetting',
      label: '基础配置状态',
      type: 'select',
      options: [
        {
          label: '完成',
          value: true,
        },
        {
          label: '未完成',
          value: false,
        },
      ],
      hideCreate: true,
      hideEdit: true,
      manualRefresh: (row) => {
        row.baseSetting = '加载中...';
        useApi()
          .weappApi.checkBaseSettingweapp({
            appid: row.appid,
          })
          .then((statusRes) => {
            row.baseSetting = statusRes.data.data;
            if (!statusRes.data.data) {
              useApi().weappApi.setBaseSettingweapp({
                appid: row.appid,
              }).then(() => {
                ElMessage.success('重新设置成功，请稍后再次刷新状态');
              });
            }
          })
          .catch(() => {
            row.baseSetting = false;
          });
      },
    },

    /* {
      name: 'privacySetting',
      label: '隐私申明状态',
      type: 'string',
      hideCreate: true,
      hideEdit: true,
      manualRefresh: (row) => {
        row.privacySetting = '加载中...';
        useApi()
          .weappApi.checkPrivacySettingweapp({
            appid: row.appid,
          })
          .then((statusRes) => {
            row.privacySetting = statusRes.data.data;
          })
          .catch(() => {
            row.privacySetting = false;
          });
      },
    }, */
    {
      name: 'localtionInterface',
      label: '定位接口状态',
      type: 'select',
      options: [
        {
          label: '待申请开通',
          value: 1,
        },
        {
          label: '无权限',
          value: 2,
        },
        {
          label: '申请中',
          value: 3,
        },
        {
          label: '申请失败',
          value: 4,
        },
        {
          label: '已开通',
          value: 5,
        },
      ],
      hideCreate: true,
      hideEdit: true,
      manualRefresh: (row) => {
        row.localtionInterface = '加载中...';
        useApi()
          .weappApi.checkPrivacyInterfaceweapp({
            appid: row.appid,
          })
          .then((statusRes) => {
            row.localtionInterface = statusRes.data.data?.find((inf: any) => inf.name === 'wx.getLocation')?.status || 0;
            if ([1, 4].includes(row.localtionInterface)) {
              useApi().weappApi.setPrivacyInterfaceweapp({
                appid: row.appid,
              }).then(() => {
                ElMessage.success('重新申请成功，请稍后再次刷新状态');
              });
            }
          })
          .catch(() => {
            row.localtionInterface = 0;
          });
      },
    },
    {
      name: 'templateId',
      label: '模板',
      type: 'select',
      rule: [{ required: true }],
      options: tplOptions,
      hideCreate: true,
      hideEdit: true,
    },
    {
      name: 'status',
      label: '发布状态',
      type: 'select',
      options: publisStatusOptions,
      hideCreate: true,
      hideEdit: true,
      manualRefresh: (row) => {
        row.status = '加载中...';
        useApi()
          .weappApi.checkStatusweapp({
            appid: row.appid,
          })
          .then((statusRes) => {
            row.status = statusRes.data.data;
          })
          .catch(() => {
            row.status = undefined;
          });
      },
    },

    {
      name: 'createTime',
      label: '授权时间',
      type: 'string',
      width: 80,
      hideCreate: true,
      hideEdit: true,
      render: ({ row: { createTime } }: any) => dayjs(createTime).format('YYYY-MM-DD HH:mm:ss'),
    },

  ];
});

const qrUrl = ref('');
const qrExpiresAt = ref('');
const visibleAuthQr = ref(false);
const qrloading = ref(false);

const topOperates: any[] = [
  {
    key: 'jumpAdd',
    name: '授权微信小程序',
    handler: async() => {
      visibleAuthQr.value = true;
      qrloading.value = true;
      try {
        const res = await useApi().weappApi.getWeappAuthUrlweapp({
          redirectUri: encodeURIComponent(`${getCurrentRootUrl()}${
            baseTenantStore.tenantInfo?.id ? `/___tenant_${baseTenantStore.tenantInfo?.id}` : ''
          }/auth?type=2`),
        });
        qrUrl.value = res.data.data?.url;
        qrExpiresAt.value = res.data.data?.expiresAt;
      } finally {
        qrloading.value = false;
      }
    },
  },
];
const operates: any[] = [

  {
    key: 'getNfcUrl',
    name: '获取NFC URL',
    handler: useBaseAsync(async(row: any) => {
      try {
        const res = await useApi().weappApi.getUrlweapp({
          appid: row.appid,
        });
        console.log(res);
        ElMessageBox.confirm(`${res?.data?.data || '-'}`, `${row.name} URL`, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          console.log('关闭');
        });
      } catch (error) {
        console.log(error);
      }
    }),
  },

  {
    key: 'setTpl',
    name: '选用模板',
    handler: (row: any) => {
      currentWeapp.value = row;
      setTplFormRef.value?.setOneFormState('templateId', row.templateId || undefined);
      setTplFormRef.value?.showDialog();
      console.log(row);
    },
  },
  {
    key: 'publish',
    name: '配置发布',
    handler: (row: any) => {
      const tpl = tpls.find((item) => item.id === row.templateId);
      if (!tpl) {
        ElMessage.error('请选用模板后再配置发布');
        return;
      }
      if (row.baseSetting !== true) {
        ElMessage.error('请刷新基础配置状态，待完成后可配置发布');
        return;
      }

      if (row.localtionInterface !== 5) {
        ElMessage.error('请刷新定位接口状态，待完成后可配置发布');
        return;
      }


      publishRef.value?.show({ ...row }, { ...tpl });
    },
  },
];

const loading = ref(false);


const getData = useBaseAsync<JuouProTableGetDataFunction>(async(filter: JuouProTableFilter) => {
  try {
    loading.value = true;
    const res = await useApi().weappApi.pageWeappweapp({
      conditions: Object.entries(filter.conditions).reduce((conditions, [key, val]) => {
        if (val === null || val === undefined || val === '') {
          return conditions;
        }
        conditions[key] = val;
        return conditions;
      }, {} as any),
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },


    });
    const tableData: JuouProTableData = {
      total: res.data.data?.total || 0,
      data: res.data.data?.data?.map((item: any) => ({
        ...item,
        localtionInterface: item.privacyInterface?.find((inf: any) => inf.name === 'wx.getLocation')?.status || 0,
      })) || [],
    };

    return tableData;
  } finally {
    loading.value = false;
  }
});

const formatDeleteInfo = (row: any) => `您正在进行删除(${row.name})操作，请谨慎操作`;


const updateFun = useBaseAsync(async(data: any) => {
  await useApi().weappApi.updateWeappweapp({
    weappAdminVo: data,
  });
  ElMessage.success('修改成功');
});


const handleSetTplOk = useBaseAsync(async(data: any) => {
  await useApi().weappApi.updateWeappweapp({
    weappAdminVo: {
      ...currentWeapp.value,
      templateId: data.templateId,
    },
  });
  ElMessage.success('设置成功');
  tableRef.value?.refresh();
});
const deleteFun = useBaseAsync(async(data: any) => {
  await useApi().weappApi.delWeappweapp(data.appid);
  ElMessage.success('删除成功');
});


init();



return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(JuouProTable), {
        ref_key: "tableRef",
        ref: tableRef,
        title: "微信小程序管理",
        paginations: { pageSize: 10 },
        columns: columns.value,
        "get-data": _unref(getData),
        "on-delete": _unref(deleteFun),
        "on-edit": _unref(updateFun),
        loading: loading.value,
        "is-dangder-delete": true,
        "format-dangder-delete-info": formatDeleteInfo,
        "row-key": "id",
        operates: operates,
        "top-operates": topOperates,
        "add-init-values": addInitValue,
        "operation-width": 380,
        "codition-init-values": conditionsInitValue
      }, null, 8, ["columns", "get-data", "on-delete", "on-edit", "loading"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: visibleAuthQr.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visibleAuthQr).value = $event)),
      title: "小程序管理员扫码授权",
      width: 320
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(QrcodeVue, {
            value: qrUrl.value,
            size: 800,
            style: {"width":"200px","height":"200px"}
          }, null, 8, ["value"]),
          _createElementVNode("div", _hoisted_3, " 过期时间：" + _toDisplayString(qrExpiresAt.value), 1),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[0] || (_cache[0] = () => { visibleAuthQr.value = false; tableRef.value?.refresh(); })
          }, {
            default: _withCtx(() => [
              _createTextVNode("已授权完成")
            ]),
            _: 1
          })
        ])), [
          [_directive_loading, qrloading.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(JuouProForm), {
      ref_key: "setTplFormRef",
      ref: setTplFormRef,
      "is-dialog": "",
      title: "选用模板",
      items: setTplItems.value,
      onOk: _unref(handleSetTplOk)
    }, null, 8, ["items", "onOk"]),
    _createVNode(publish, {
      ref_key: "publishRef",
      ref: publishRef,
      onClose: _cache[2] || (_cache[2] = () => tableRef.value?.refresh())
    }, null, 512)
  ], 64))
}
}

})